<template>
  <div class="paydeteilpage">
    <div class="paydeteilpageflex1">
      <div class="paylist">
        <span class="listline"></span>
        <p class="paylisttit">
          <span class="title">就诊信息</span>
        </p>
        <div class="payliscon">
          <p>
            <span>就诊人：</span>
            <span>{{chargeList.PatName}}</span>
          </p>
          <p>
            <span>就诊号：</span>
            <span>{{chargeList.Code}}</span>
          </p>
          <p>
            <span>就诊科室：</span>
            <span>{{chargeList.DptName}}</span>
          </p>
          <p>
            <span>就诊医生：</span>
            <span>{{chargeList.DctName}}</span>
          </p>
          <p>
            <span>就诊时间：</span>
            <span>{{chargeList.VisitTime}}</span>
          </p>
        </div>
      </div>
      <div class="drugdeteil" v-for="(model,index) in chargeList.Detail">
        <span class="listline"></span>
        <p class="paylisttit">
          <input
            type="radio"
            :class="{'radiochecked':model.IsCheck}"
            :value="model.OrderNumber"
            @click="checkedFun(model)"
          />
          <span>{{model.Name}}</span>
        </p>
        <div class="payliscon">
          <div class="drug">
            <p class="bg">
              <span>项目名称</span>
              <span>数量</span>
              <span>总价</span>
            </p>
            <p v-for="item in model.Detail">
              <span>{{item.Name}}</span>
              <span>{{item.Quantity}}</span>
              <span>{{item.Amount}}</span>
            </p>
            <div class="amount">
              <span>总计：</span>
              <span></span>
              {{model.Amount}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="noDate noDatestyle" v-show="!isShow">
      <div v-show="true" class="nolist">
        <!-- 无数据显示 -->
        <img src="../../assets/images/searchbg.png" alt class="searchpic" />
        <p class="center">暂无数据</p>
      </div>
    </div>
    <div class="payfooter" v-show="isShow">
      <div class="payflex">
        <div class="inblock">
          <input type="radio" @click="countRadio(checkAllFlag)" :class="{'radiochecked':cheeckAll}" />
          <span>全选</span>
        </div>
        <div class="m50 inblock">
          <span>合计：</span>
          <span class="red">{{amount | numFilter}}</span>
        </div>
      </div>

      <div class="paybtn" @click="medicalPay">
        <span>医保支付</span>
      </div>
      <div class="paybtn" @click="paysure">
        <span>支付</span>
      </div>
    </div>
  </div>
</template>
<script>
import {
  GetChargeItemByVisitID,
  GetHISAddChargeModel,
  WeiXinCharge,
  AddHisCharge,
  SetItem,
  RemoveItem,
  GetMedicalInsuranceUrl
} from "@/services/getData.js";
import weui from "weui.js";
export default {
  name: "outpatient-name",
  data() {
    return {
      checkAllFlag: false,
      cheeckAll: false,
      chargeList: {},
      visitID: this.$route.query.visitID,
      amount: 0,
      chargeItme: "",
      $dialog: [],
      isShow: true
    };
  },
  created: function() {
    this.getChargeItemByVisitID();
  },
  destroyed: function() {
    if (Object.prototype.toString.call(this.$dialog) !== "[object Function]") {
      this.$dialog.hide();
    }
  },
  methods: {
    paysure() {
      var _that = this;
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      this.chargeItme = "";
      this.chargeList.Detail.forEach((item, index) => {
        if (item.IsCheck) {
          _that.chargeItme += item.GUID + ",";
        }
      });
      if (this.chargeItme.length > 0) {
        this.chargeItme = this.chargeItme.substring(
          0,
          this.chargeItme.length - 1
        );
      } else {
        this.$dialog = weui.dialog({
          title: "提示",
          content: "请选择收费项"
        });
        loading.hide();
        return;
      }
      var sendData = GetHISAddChargeModel(
        this.visitID,
        this.chargeItme,
        this.chargeList.HosID
      );
      var _that = this;
      WeiXinCharge(sendData).then(data => {
        var returnString = data.split("_");
        if (returnString[0] == "ok") {
          loading.hide();
          this.$router.push({
            path: "/pay/outpatientpaysus",
            query: { outOrder: returnString[1] }
          });
        } else if (returnString[0] == "cancel") {
          loading.hide();
          DeletePayRecord(returnString[1]).then(response => {
            if (response.data.Result) {
              _that.$dialog = weui.dialog({
                title: "提示",
                content: "支付失败"
              });
            } else {
              _that.$dialog = weui.dialog({
                title: "提示",
                content: response.data.Content
              });
            }
          });
        } else if (returnString[0] == "fail") {
          loading.hide();
          DeletePayRecord(returnString[1]).then(response => {
            if (response.data.Result) {
              _that.$dialog = weui.dialog({
                title: "提示",
                content: "支付失败"
              });
            } else {
              _that.$dialog = weui.dialog({
                title: "提示",
                content: response.data.Content
              });
            }
          });
        } else if (returnString[0] == "no") {
          loading.hide();
        } else {
          loading.hide();
        }
      });
    },
    getChargeItemByVisitID() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetChargeItemByVisitID(this.visitID).then(response => {
        loading.hide();
        if (response.data) {
          this.chargeList = response.data;
          console.info(this.chargeList);
          if (response.data.Detail.length > 0) {
            this.isShow = true;
          } else {
            this.isShow = false;
          }
          this.countRadio(false);
        }
      });
    },
    //全选
    countRadio(flag) {
      // if ( this.chargeList.Detail.some(item => item.IsCheck == true)) {
      //           this.chargeList.Detail.forEach((item, index) => {
      //           item.IsCheck = true
      //         });
      // }
      this.checkAllFlag = !flag;
      this.cheeckAll = this.checkAllFlag; //全选样式控制
      this.chargeList.Detail.forEach((item, index) => {
        item.IsCheck = this.checkAllFlag;
      });
      this.calcTotalPrice();
    },
    //单选
    checkedFun(model) {
      model.IsCheck = !model.IsCheck;
      if (this.chargeList.Detail.every(item => item.IsCheck === true)) {
        //单选控制全选
        this.cheeckAll = true;
      } else {
        this.cheeckAll = false;
      }
      this.chargeList.Detail.forEach((item, index) => {
        if (item.RxID) {
          if (model.RxID == item.RxID) {
            item.IsCheck = model.IsCheck;
          }
        }
      });
      this.calcTotalPrice();
    },
    //合计求和
    calcTotalPrice: function() {
      let that = this;
      that.amount = 0; //每次遍历之前对总金额进行清零
      this.chargeList.Detail.forEach((item, index) => {
        if (item.IsCheck) {
          that.amount += item.Amount;
        }
      });
    },
    medicalPay() {
      var _that = this;
      this.chargeItme = "";
      this.chargeList.Detail.forEach((item, index) => {
        if (item.IsCheck) {
          _that.chargeItme += item.GUID + ",";
        }
      });
      if (this.chargeItme.length > 0) {
        this.chargeItme = this.chargeItme.substring(
          0,
          this.chargeItme.length - 1
        );
      } else {
        this.$dialog = weui.dialog({
          title: "提示",
          content: "请选择收费项"
        });
        loading.hide();
        return;
      }
      var sendData = GetHISAddChargeModel(
        this.visitID,
        this.chargeItme,
        this.chargeList.HosID
      );
      sendData.Amount = this.amount
      SetItem('sendData',JSON.stringify(sendData))
      GetMedicalInsuranceUrl(sendData).then(res=> {
        if(res.data.Result == false) {
          alert(res.data.Content);
          return;
        } else {
          window.location.href = res.data.Extend;
        }
      })
    },
  },
  filters: {
    numFilter(value) {
      // 截取当前数据到小数点后两位
      let realVal = parseFloat(value).toFixed(2);
      return realVal;
    }
  }
};
</script>
<style scoped>
.paydeteilpage {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.paydeteilpage .paylist {
  /* padding: 0 0.2rem; */
  box-sizing: border-box;
  width: 100%;
  height: auto;
  background-color: white;
  position: relative;
  margin-bottom: 0.2rem;
}

.paydeteilpage .paylisttit {
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #1592e4;
  border-bottom: 0.01rem solid rgba(61, 151, 209, 1);
  height: 0.79rem;
  line-height: 0.8rem;
  padding-left: 0.2rem;
  box-sizing: border-box;
  width: 100%;
}

.paydeteilpage .payliscon {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.2rem;
}

.paydeteilpage .paylist > .payliscon > p {
  width: 100%;
  border-bottom: 0.01rem dotted #dddddd;
  height: 0.79rem;
  line-height: 0.8rem;
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  font-style: normal;
  display: block;
}

.paydeteilpage .paylist > .payliscon > p > span:first {
  color: #333333;
  text-align: left;
}

.paydeteilpage .paylist > .payliscon > p > span:last-child {
  color: #999999;
  text-align: right;
  float: right;
}

.paydeteilpage .paylist > .payliscon > p:last-child {
  border-bottom: none;
}

.paydeteilpage .listline {
  display: block;
  position: absolute;
  width: 0.08rem;
  height: 0.8rem;
  background: rgba(21, 146, 228, 1);
  top: 0;
  left: 0;
}

.paydeteilpage .drugdeteil {
  font-size: 0.2rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  background: white;
  position: relative;
  margin-bottom: 0.2rem;
}

.paydeteilpage .drugdeteil .drug {
  border: 0.01rem solid #dddddd;
  margin: 0.2rem 0;
}

.paydeteilpage .drugdeteil .drug > p {
  display: flex;
  flex-direction: row;
  line-height: 0.35rem;
  margin-bottom: 0.21rem;
}

.paydeteilpage .drugdeteil .drug > p > span:first-child {
  width: 60%;
  box-sizing: border-box;
  padding-left: 0.43rem;
}

.paydeteilpage .drugdeteil .drug > p > span:nth-child(2) {
  width: 20%;
}

.paydeteilpage .drugdeteil .drug > p > span:last-child {
  width: 20%;
  text-align: center;
}

.paydeteilpage .drugdeteil .drug .amount {
  text-align: right !important;
  color: red;
  box-sizing: border-box;
  padding-right: 0.25rem;
  border-top: 0.01rem solid #dddddd;
  line-height: 0.6rem;
}

.paydeteilpage .drugdeteil .drug .bg {
  background: #f2f2f2;
  height: 0.6rem;
  line-height: 0.6rem;
}

.paydeteilpage .payfooter {
  background: white;
  display: flex;
  flex-direction: row;
  padding-left: 0.2rem;
  box-sizing: border-box;
  border-top: 0.01rem solid rgba(61, 151, 209, 1);
  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  width: 100%;
  height: 0.8rem;
}

.paydeteilpageflex1 {
  flex: 1;
  overflow: auto;
}

/* .paydeteilpage .payfooter > div {
    float: left;
    padding: 0.3rem 0;
  } */

.paybtn {
  background: #1592e4;
  text-align: center;
  color: white;
  height: 0.8rem;
  border-left: 0.001rem solid #fff;
  line-height: 0.8rem;
  width: 20%;
}

.paydeteilpage .payfooter .payflex {
  margin-top: 0.22rem;
  flex: 1;
}

.paydeteilpage .m50 {
  margin-left: 0.5rem;
}

.paydeteilpage .payfooter .red {
  color: red !important;
}

.radiochecked {
  display: inline-block;
  position: relative;
  color: #fff;
  font-weight: 400;
  z-index: 1;
  background-color: #1592e4;
  padding-left: -0.15rem;
  border-radius: 50%;
  padding-left: 0.05rem;
  box-sizing: border-box;
  width: 0.28rem;
  height: 0.28rem;
  background-image: url("../../assets/images/check.png") !important;
  background-position: center center !important;
}

.inblock {
  display: inline-block;
}

.noDatestyle {
  flex: 1;
  position: relative;
}

.noDatestyle .nolist {
  margin-top: -2rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/outpatientpay/outpatient-deteil.vue